import { useState } from "react";
import { LuLayoutDashboard } from "react-icons/lu";
import ProductsNavbar from "../../components/Products/ProductsNavbar";
import ProductsCategories from "./ProductsCategories";
import ProductsBrands from "./ProductsBrands";
import ProductsTags from "./ProductsTags";
import Products from "./Products";
import { useTranslation } from "react-i18next";
import CardHeadeWithActions from "../../components/ui/CardHeadeWithActions";
import OSListsPriceses from "./OSListsPriceses";
import { MdOutlineAddBox } from "react-icons/md";
import MwButton from "./../../components/ui/MwButton";

const ProductsHome = () => {
  const [t, i18n] = useTranslation("global");
  const isRTL = i18n.dir() === "rtl";
  const [mode, setMode] = useState("List");

  const [tabActive, setTabActiive] = useState("Products");

  return (
    <div className="w-[100%] mx-auto">
      <CardHeadeWithActions
        icon={<LuLayoutDashboard size={18} />}
        title={t("product.productsServicesManagement")}
      >
        <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("Add")}>
          <MdOutlineAddBox size={18} />
          {t("product.createNewProduct")}
        </MwButton>
      </CardHeadeWithActions>

      <ProductsNavbar className={"!w-[98%] mx-auto "} tabActive={tabActive} setTabActiive={setTabActiive} />

      <div id="tab" className="bg-slate-100  rounded-b-lg">
        <div
          id="Products"
          className={`flex flex-col w-[98%] mx-auto gap-2 ${tabActive === "Products" ? "block" : "hidden"} `}
        >
          <Products setMode={setMode} mode={mode} />
        </div>
        <div
          id="Prices"
          className={`flex w-[98%] mx-auto flex-col gap-2 ${tabActive === "Prices" ? "block" : "hidden"} `}
        >
          <OSListsPriceses />
        </div>
        <div
          id="Categories"
          className={`flex flex-col w-[98%] mx-auto gap-2 ${tabActive === "Categories" ? "block" : "hidden"} `}
        >
          <ProductsCategories />
        </div>
        <div
          id="Brands"
          className={`flex flex-col w-[98%] mx-auto gap-2 ${tabActive === "Brands" ? "block" : "hidden"} `}
        >
          <ProductsBrands />
        </div>
        <div
          id="Tags"
          className={`flex flex-col w-[98%] mx-auto gap-2 ${tabActive === "Tags" ? "block" : "hidden"} `}
        >
          <ProductsTags />
        </div>
      </div>
    </div>
  );
};

export default ProductsHome;
